import React, { useEffect, useState } from "react";
import axios from "axios";
import Editor from "../../../layout/editor";

const ContractorToolsBox = ({ profile, isEdit, form, handlerChanges }) => {
    const [toolsData, setToolsData] = useState([]);
    const [selectedTools, setSelectedTools] = useState(new Set());
    const [openedWorkTypes, setOpenedWorkTypes] = useState(new Set());

    useEffect(() => {
        axios
            .get("/api/users/fetch_tools_detail")
            .then((res) => setToolsData(res.data.tools || []))
            .catch((err) => console.error("Error loading tools:", err));
    }, []);

    useEffect(() => {
        if (profile?.tools?.length) {
            setSelectedTools(new Set(profile.tools.map((item) => item.toolss)));
        }
    }, [profile]);

    useEffect(() => {
        const source = form?.tools?.length ? form.tools : profile?.tools;
        if (source?.length) {
            setSelectedTools(new Set(source.map((item) => item.toolss)));
        }
    }, [form?.tools, profile?.tools]);

    const toggleTool = (toolName) => {
        const updated = new Set(selectedTools);

        if (updated.has(toolName)) {
            updated.delete(toolName);

            if (toolName === "Minimum Toolbox") {
                const keepManager = selectedTools.has("Project Management Toolbox");
                updated.clear();
                if (keepManager) updated.add("Project Management Toolbox");
            }
        } else {
            updated.add(toolName);
        }

        setSelectedTools(updated);
        handlerChanges({
            name: "tools",
            value: [...updated].map((item) => ({ toolss: item })),
        });

        const newOpened = new Set(openedWorkTypes);
        if (newOpened.has(toolName)) newOpened.delete(toolName);
        else newOpened.add(toolName);
        setOpenedWorkTypes(newOpened);
    };

    const isToolEnabled = (toolName) =>
        isEdit && (selectedTools.has("Minimum Toolbox") || toolName === "Project Management Toolbox");

    return (
        <div className="toolbox_container">
            {/* === Minimum Toolbox === */}
            <div className="toolbox_section">
                <div className="toolbox_header">
                    <h3 className="toolbox_title">Minimum Toolbox</h3>
                    <span className="required_label">REQUIRED</span>
                </div>

                <label className="check_btn">
                    <input
                        type="checkbox"
                        name="minimum_toolbox"
                        checked={selectedTools.has("Minimum Toolbox")}
                        onChange={() => isEdit && toggleTool("Minimum Toolbox")}
                    />
                    I have a standard minimum tools and equipment needed for all work.
                </label>

                <div className="toolbox_items">
                    <div className="item_label">Standard Toolbox Items:</div>
                    <div className="item_text">
                        66/110 punch down tool, buttset, RJ45 crimpers, cable tester, 8'
                        ladder, zip ties, velcro, smart phone, Toner, fish tape, hammer
                        drill, Cordless Drill, PTouch Labeler or similar
                    </div>
                </div>

                <div className="toolbox_items">
                    <div className="item_label">Standard Materials:</div>
                    <div className="item_text">
                        Patch cables, Cat5 cable, RJ45 connectors, button clips, 3M gel connectors
                    </div>
                </div>

                {/* === Toolbox Categories === */}
                <div className="toolbox_categories">
                    {toolsData.map((tool) => (
                        <button
                            key={tool.title}
                            type="button"
                            className={`toolbox_category ${selectedTools.has(tool.title) ? "active" : ""}`}
                            disabled={!isToolEnabled(tool.title)}
                            onClick={() => isToolEnabled(tool.title) && toggleTool(tool.title)}
                        >
                            {tool.title}
                        </button>
                    ))}
                </div>
            </div>

            {/* === Dynamic Toolbox Details === */}
            {toolsData.map((tool) => (
                <div className="toolbox_detail_section" key={tool.title}>
                    <h3 className="toolbox_title">{tool.title}</h3>
                    <label className="check_btn">
                        <input
                            type="checkbox"
                            checked={selectedTools.has(tool.title)}
                            disabled={!isToolEnabled(tool.title)}
                            onChange={() => isToolEnabled(tool.title) && toggleTool(tool.title)}
                        />
                        I have a standard minimum tools and equipment needed for all work.
                    </label>

                    <div className="toolbox_items">
                        <div className="item_label">Standard Toolbox Items:</div>
                        <div className="item_text">{tool.tools.join(", ")}</div>
                    </div>

                    <div className="toolbox_items">
                        <div className="item_label">Standard Materials:</div>
                        <div className="item_text">{tool.materials.join(", ")}</div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ContractorToolsBox;
